module.exports = __webpack_public_path__ + "07_long_black.e08cc54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/07_long_black.png
// module id = 6+Bw
// module chunks = 0